import { render } from "./PageTopo.vue?vue&type=template&id=4becc0d2&scoped=true"
import script from "./PageTopo.vue?vue&type=script&lang=js"
export * from "./PageTopo.vue?vue&type=script&lang=js"

import "./PageTopo.vue?vue&type=style&index=0&id=4becc0d2&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4becc0d2"]])

export default __exports__